import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

let modules = {}
const moduleContext = require.context('./modules', false, /\.js$/)
moduleContext.keys().forEach(path => {
  const name = path.match(/\/(\S*)\./)[1]
  modules[name] = moduleContext(path).default
})

export default new Vuex.Store({
  modules
})
